import CompanyAccountsPage from 'src/components/pages/Company/CompanyAccountsPage/CompanyAccountsPage';

export default CompanyAccountsPage;
